<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="text-center">Thème {{"«" + sessionDetail['detail'].theme + "»"}} - Session [{{ sessionDetail["detail"].realId }}]</h3>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-3">
                Session Id :
            </div>
            <div class="col-md-9">
                {{ sessionDetail["detail"].realId }}
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                Lien CRM :
            </div>
            <div class="col-md-9">
                <a :href="`https://crm.zoho.eu/crm/EntityInfo.do?module=CustomModule1&id=${sessionDetail['detail'].realId}`" target="_blank" rel="noopener">https://crm.zoho.eu/crm/EntityInfo.do?module=CustomModule1&id={{ sessionDetail["detail"].realId }}</a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                Session Nom :
            </div>
            <div class="col-md-9">
                {{ sessionDetail["detail"].name }}
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                Session Début :
            </div>
            <div class="col-md-9">
                {{ sessionDetail["detail"].startAt }}
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                Session Fin :
            </div>
            <div class="col-md-9">
                {{ sessionDetail["detail"].endAt }}
            </div>
        </div>
        <div class="row" v-if="sessionDetail.detail.hasFinishedChildren">
            <div class="col-md-3">
                Statistiques session :
            </div>
            <div class="col-md-9">
                <button type="button" class="btn btn-success" @click="displayStatistics()">Statistiques</button>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-12">
                <h4 class="text-left">Utilisateurs</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Login</th>
                            <th>Nom</th>
                            <th>Prénom</th>
                            <th>Dernière connexion</th>
                            <th>Lien CRM</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in sessionDetail.users" :key="user.id">
                            <td>{{ user.detail.userName }}</td>
                            <td>{{ user.detail.lastName }}</td>
                            <td>{{ user.detail.firstName }}</td>
                            <td v-if="user.detail.lastLogin == null">Aucune connexion</td>
                            <td v-else>{{ formatDate(user.detail.lastLogin) }}</td>
                            <td><a :href="`https://crm.zoho.eu/crm/EntityInfo.do?module=Potentials&id=${user.realId}`" target="_blank" rel="noopener">https://crm.zoho.eu/crm/EntityInfo.do?module=Potentials&id={{ user.realId }}</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <modalStatisticsBlock v-if="sessionDetail.detail.hasFinishedChildren" :group="true" :results="true" :satisfaction="true"></modalStatisticsBlock>
    </div>
</template>

<script>
    import ModalStatisticsBlock from 'components/ModalStatisticsBlock';

    export default {
        components: {
            ModalStatisticsBlock
        },
        computed: {
            sessionDetail: function() {
                return this.$store.state.admin.sessionDetail;
            }
        },
        methods: {
            formatDate(date)  {
                let d = new Date(date);
                return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear() + ' - ' + d.getHours() + ':' + d.getMinutes().toString().padStart(2, "0");
            },
            displayStatistics()	{
                this.$store.commit('DISPLAY_MODAL_STATISTICS', true);
            }
        },
        data: function()  {
            return {
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                backText: "Retour aux sessions",
                pathData: {
                    name: "TemplateSessions",
                    params: {
                        templateId: this.$route.params.templateId
                    }
                }
            });
        }
    };
</script>

<style>


</style>
